import { useCustomT } from '@crimeos-frontend/shared/common'

import { showFailureToastWithGivenMessage } from '../../../utils/ToastUtils'
import { DeleteFilesInFileUploadEntityMutation as Mutation } from './mutation.generatedTypes'

interface HandleResponseArgsType {
  response: Mutation

  onSuccess?: () => void
}

interface ReturnType {
  handleResponse: (args: HandleResponseArgsType) => void
}

const useResponseHandler = (): ReturnType => {
  const commonErrorT = useCustomT('common:apiErrorMessages')

  const handleResponse: ReturnType['handleResponse'] = args => {
    const hasEmptyResponse =
      !args.response || !args.response.deleteFilesInFileUploadEntity

    if (hasEmptyResponse)
      throw new Error('deleteFilesInFileUploadEntity not found')

    const data = args.response.deleteFilesInFileUploadEntity
    switch (data.__typename) {
      case 'DeleteFilesInFileUploadEntityResult': {
        args.onSuccess?.()
        break
      }

      case 'FileUploadEntityAccessDenied':
      case 'FileUploadEntityNotFound':
      case 'FileUrlsNotInGivenFileUploadEntityPath':
        showFailureToastWithGivenMessage(
          data.message || commonErrorT(data.__typename)
        )
        break

      default:
        throw new Error(
          '__typeName: Invalid deleteFilesInFileUploadEntity Response'
        )
    }
  }

  return {
    handleResponse
  }
}

export default useResponseHandler
